import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { useCompetitionResults, useResultsEventListState } from "../store";
import { CopmetitionResultEventCompetitions } from "../competitions/view";
import { cls_box_caption, cls_box_gap, cls_item_box, cls_item_city, cls_item_date_box, cls_item_date_day, cls_item_date_month, cls_item_detail_link, cls_item_name, } from "./view.css";
import { cls_backgroundBlack, cls_backgroundWhite, cls_colorBlack, cls_colorCyan70, cls_colorGrey90, cls_colorMagenta60, cls_colorWhite, cls_cursor_pointer, cls_display_none, cls_gap_form, cls_gap_half_rem, cls_gap_line, cls_h4, cls_h6, cls_h9, cls_p5r, cls_rotate_180deg, cls_rotate_90deg, cls_visibility_hidden, } from "style/index.css";
import { Filter } from "../filter/view";
import { cls_align_items_center, cls_align_items_stretch, cls_justify_content_center } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { useif } from "framework/state/types";
import { ButtonNoStyle } from "framework/controls/button";
import { cls_chevron_right_black_box, cls_icon_box_size_24px } from "style/icons.css";
import { Link } from "framework/link/link";
import { UrlPathOfPublicSection } from "common/paths";
import { Checkbox } from "framework/controls/checkbox";
import { useUIContext } from "common/uicontext/store";
var nowIsSameDayOrOneDayAfterEvent = function (eventDateFrom, eventDateTo) {
    var dateNow = new Date();
    if (!(eventDateFrom instanceof Date) || !(eventDateTo instanceof Date)) {
        return false;
    }
    var dNow = new Date(dateNow);
    var dEventFrom = new Date(eventDateFrom);
    var dEventTo = new Date(eventDateTo);
    dNow.setHours(0, 0, 0, 0);
    dEventFrom.setHours(0, 0, 0, 0);
    dEventTo.setHours(0, 0, 0, 0);
    var diffInMillisecondsDateTo = dNow.getTime() - dEventTo.getTime();
    var millisecondsInDay = 24 * 60 * 60 * 1000;
    return diffInMillisecondsDateTo === millisecondsInDay
        || (dEventFrom.getTime() <= dNow.getTime() && dNow.getTime() <= dEventTo.getTime());
};
var CopmetitionResultEvent = function (props) {
    var _a, _b;
    var _c = useCompetitionResults(), state = _c[0], actions = _c[1];
    var month = props.eventInfo.dateFrom.toLocaleString('default', { month: 'short' });
    var day = props.eventInfo.dateFrom.getDate();
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var eventId = props.eventInfo.eventId;
    var city = props.eventInfo.location;
    var showCompetitions = state.eventList.openEventIds.includes(eventId);
    var allowRefresh = nowIsSameDayOrOneDayAfterEvent(props.eventInfo.dateFrom, props.eventInfo.dateTo);
    var refreshEvent = function (event) {
        event.stopPropagation();
        actions.reloadEventResults(eventId);
    };
    var eventContainer = state.eventContainers[eventId.toString()];
    var eventLoading = eventContainer.event.loading;
    var eventInfigilatorReportUpdating = eventContainer.eventReport.updating;
    var uicontext_state = useUIContext()[0];
    var isSportVicepresident = uicontext_state.data.event_planning.isSportVicepresident;
    var isGeneralInvigilator = state.eventContainers[eventId.toString()].isGeneralInvigilator;
    var isCompetitionCommissioner = state.eventContainers[eventId.toString()].isCompetitionCommissioner;
    var invigilatorReportApproved = (_a = eventContainer.event.entity) === null || _a === void 0 ? void 0 : _a.invigilatorReportPublicationApproved;
    var invigilatorReportExists = invigilatorReportApproved === true || invigilatorReportApproved === false;
    var showInvigilatorReportComponent = showCompetitions && invigilatorReportExists;
    var showInvigilatorReport = invigilatorReportApproved || isGeneralInvigilator || isCompetitionCommissioner || isSportVicepresident;
    var showInvigilatorReportApprovalCheckbox = showInvigilatorReportComponent && (isGeneralInvigilator || isCompetitionCommissioner || isSportVicepresident);
    React.useEffect(function () {
        actions.loadUIContextForEventPlanning(eventId);
    }, [(_b = uicontext_state.data.logged_user) === null || _b === void 0 ? void 0 : _b.email, eventId]);
    var showInvigilatorReportGetter = function (field) {
        return invigilatorReportApproved === true;
    };
    var showInvigilatorReportSetter = function (field, value, validator, storeInvalidValue) {
        return actions.changeInvigilatorReportApproval(eventId, value);
    };
    return React.createElement(VBox, { className: [cls_item_box, cls_gap_half_rem] },
        React.createElement(ButtonNoStyle, { onClick: function () { return actions.setEventOpenOrClosed(eventId); } },
            React.createElement(HBox, { className: [cls_gap_line, cls_cursor_pointer] },
                React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] },
                    React.createElement(HBox, { className: [cls_h9, cls_item_date_month, cls_justify_content_center, cls_align_items_center, cls_colorWhite, cls_backgroundBlack] }, month),
                    React.createElement(HBox, { className: [cls_h4, cls_item_date_day, cls_justify_content_center, cls_align_items_center, cls_colorBlack, cls_backgroundWhite] }, day)),
                React.createElement(VBox, { className: cls_gap_half_rem },
                    React.createElement(HBox, { className: [cls_gap_line, cls_item_city, cls_align_items_center, cls_h9, cls_colorGrey90] }, city || React.createElement(HBox, { className: cls_visibility_hidden }, "-")),
                    React.createElement(HBox, { className: [cls_gap_form] },
                        React.createElement(HBox, { className: [cls_item_name, cls_h6] }, props.eventInfo.eventTitle),
                        React.createElement(HBox, { className: [cls_chevron_right_black_box, cls_icon_box_size_24px, cls_justify_content_center, cls_align_items_center, useif(!showCompetitions, cls_rotate_180deg), useif(showCompetitions, cls_rotate_90deg)] }))))),
        showInvigilatorReportComponent && React.createElement(HBox, { className: cls_gap_line },
            !T_HFM && React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] }),
            React.createElement(HBox, { className: [cls_p5r] }, showInvigilatorReport
                ? React.createElement(HBox, { className: cls_colorCyan70 },
                    React.createElement(Link, { url: "".concat(UrlPathOfPublicSection, "/vysledky_soutezi/event/").concat(props.eventInfo.eventId, "/invigilator_report"), className: cls_item_detail_link }, "Zpr\u00E1va odborn\u00E9ho dozoru"))
                : React.createElement(HBox, { className: cls_colorGrey90 }, "Zpr\u00E1vu odborn\u00E9ho dozoru komisa\u0159 nezve\u0159ejnil."))),
        showInvigilatorReportApprovalCheckbox && React.createElement(HBox, { className: cls_gap_line },
            !T_HFM && React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] }),
            React.createElement(VBox, { className: cls_gap_half_rem },
                React.createElement(Checkbox, { label: "Zpr\u00E1va m\u016F\u017Ee b\u00FDt ve\u0159ejn\u00E1", getter: showInvigilatorReportGetter, setter: showInvigilatorReportSetter, disabled: eventLoading || eventInfigilatorReportUpdating }),
                state.eventContainers[eventId.toString()].eventReport.updateFailure && React.createElement(HBox, { className: [cls_colorMagenta60, cls_p5r] }, "Akce se nezda\u0159ila."))),
        showCompetitions && React.createElement(HBox, { className: cls_gap_line },
            !T_HFM && React.createElement(VBox, { className: [cls_item_date_box, cls_align_items_stretch] }),
            React.createElement(CopmetitionResultEventCompetitions, { eventState: props.eventState })),
        showCompetitions && allowRefresh && React.createElement(HBox, { className: [cls_justify_content_center, useif(eventLoading, cls_visibility_hidden)] },
            React.createElement(ButtonNoStyle, { onClick: refreshEvent, disabled: eventLoading },
                React.createElement(HBox, { className: [cls_p5r, cls_colorCyan70, cls_cursor_pointer] }, "Na\u010D\u00EDst znovu"))));
};
var Content = function () {
    var _a;
    var _b = useCompetitionResults(), state = _b[0], actions = _b[1];
    var collection = useResultsEventListState()[0].collection;
    var _c = useUIContext(), uicontext_state = _c[0], uicontext_actions = _c[1];
    React.useEffect(function () {
        actions.resetCompetitionResultEntity();
    }, []);
    React.useEffect(function () {
        uicontext_actions.loadEventPlanningUIContext();
    }, [(_a = uicontext_state.data.logged_user) === null || _a === void 0 ? void 0 : _a.email]);
    return React.createElement(VBox, null, collection.map(function (e) {
        var visible = new Date() > e.dateFrom;
        var event = state.eventContainers[e.eventId.toString()].event;
        return React.createElement(VBox, { key: e.eventId, className: useif(!visible, cls_display_none) }, visible ? React.createElement(VBox, null,
            React.createElement(HBox, null,
                React.createElement(CopmetitionResultEvent, { eventInfo: e, eventState: event }))) : null);
    }));
};
var View = function () {
    var _a = useResultsEventListState(), state = _a[0], actions = _a[1];
    var loadFailure = state.loadFailure, loadingTooLong = state.loadingTooLong;
    React.useEffect(function () {
        if (state.firstLoadingSubmitted === false) {
            actions.loadCompetitionEventsAction();
        }
    }, [state.firstLoadingSubmitted]);
    return React.createElement(VBox, null,
        React.createElement(HBox, { className: cls_box_caption },
            React.createElement("h3", { className: cls_colorCyan70 }, 'Výsledky soutěží')),
        React.createElement(Filter, null),
        React.createElement(HBox, { className: cls_box_gap }),
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null),
        React.createElement(Content, null));
};
export { View as CompetitionResultEvents, };
